import type { LocaleCopy } from '../types';
import { homeRo } from './home';
import { chromeRo } from './chrome';
import { aboutRo } from './about';
import { allergensRo } from './allergens';

export const ro: LocaleCopy = {
  home: homeRo,
  chrome: chromeRo,
  about: aboutRo,
  allergens: allergensRo,
};
